"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="255546" id="hero-section" className="relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/roofing_crew_completed_project.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/roofing_crew_completed_project.png-wvc-srcset" data-wvc-sizes="100vw" alt="Professional roofing crew at work" className="w-full h-full object-cover" loading="eager" decoding="async" />
        <div className="absolute inset-0 bg-primary-900/60" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 py-24 md:py-32 flex flex-col items-center text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 data-heading="h1" className="font-default font-bold text-[42px] md:text-[56px] leading-[1.1] text-white mb-6 max-w-5xl drop-shadow-md">
          Professional Roofing &{" "}
          <span className="text-secondary-500">
            Exterior Services
          </span>{" "}
          for Maryland Homeowners
        </h1>

        <h2 className="font-default font-normal text-[18px] md:text-[20px] text-white/90 max-w-2xl mb-10 drop-shadow-sm">
          Providing Maryland homeowners with expert roof repair, roof replacement, siding installation, and gutter systems. We deliver quality craftsmanship that protects your home for years to come.
        </h2>

        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          <Button asChild className="bg-secondary-500 hover:bg-secondary-500/90 text-white text-lg px-8 py-6 h-auto rounded-md w-full sm:w-auto shadow-lg transition-all">
            <Link to="/ContactPage">
              Schedule Free Expert Assessment
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>

          <Button asChild variant="outline" className="border-2 border-white text-white hover:bg-white/10 font-default font-semibold text-lg px-8 py-6 h-auto rounded-md bg-transparent backdrop-blur-sm w-full sm:w-auto transition-colors">
            <Link to="tel:1234567890">
              Call Now
            </Link>
          </Button>
        </div>

        <div className="mt-6 flex flex-col items-center gap-2">
          <Link to="tel:2408991278" className="text-white hover:text-secondary-500 transition-colors font-medium">
            Or call (240) 899-1278 for immediate help
          </Link>
          <p className="text-white/70 text-sm">
            No credit card required. Takes 15 minutes.
          </p>
        </div>
      </div>
    </section>;
}